import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { CommonFormContextProps, SaveButton, useCommonFormContextProps } from 'components/Form'
import { PageHeader } from 'components/Header'
import {
  PrebidModulesContext,
  PrebidModulesContextType,
} from 'features/globalSetup/contexts/PrebidModulesContext'
import { AddContainer } from 'features/globalSetup/forms/Prebid/Modules/AnalyticsAdaptersForm/GeneralForm'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'

export const AnalyticsAdaptersAdd = (): React.JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation(['features/globalSetup', 'common'])
  const [saveButtonText, setSaveButtonText] = useState<string>('')

  const commonContextProps: CommonFormContextProps = useCommonFormContextProps({
    formId: 'prebid-modules-analytics-adapters-form-add',
  })
  const contextProps: PrebidModulesContextType = {
    saveButtonText,
    setSaveButtonText,
    ...commonContextProps,
  }

  return (
    <PrebidModulesContext.Provider value={contextProps}>
      <PrebidModulesContext.Consumer>
        {(ctxProps: PrebidModulesContextType): React.JSX.Element => (
          <PageHeader
            actions={
              <SaveButton
                {...ctxProps}
                text={saveButtonText}
              />
            }
            backTo={generatePath(ROUTES.GLOBAL_SETUP.PREBID.MODULES.ANALYTICS.LIST, {
              workspaceId,
            })}
            title={t('prebid.modules.analytics.add.title')}
          />
        )}
      </PrebidModulesContext.Consumer>

      <AddContainer />
    </PrebidModulesContext.Provider>
  )
}
